import BaseController from "confinus_ui/base_controller";
import { DecorSuiteFormsSearchableSelectIdentifier } from "decor";
import { ModalEvents } from "lib/overlay/modal";

interface SearchableSelectSelectedDetail {
  id: string | number;
  label: string;
  metadata?: { purcon_path?: string };
}

const SEARCHABLE_SELECT_SELECTED_EVENT = `${DecorSuiteFormsSearchableSelectIdentifier}:selected`;

// Bridges the SearchableSelect `selected` event into a Modal `open` dispatch
// so the already-open Add-line-item dialog swaps its body to the purcon
// fragment in place — no second modal, no SKU-validation round-trip.
export default class AddLineItemPickerController extends BaseController {
  private boundOnSelected!: (event: Event) => void;

  connect() {
    super.connect();
    this.boundOnSelected = (event) =>
      this.productSelected(
        event as CustomEvent<SearchableSelectSelectedDetail>,
      );
    this.element.addEventListener(
      SEARCHABLE_SELECT_SELECTED_EVENT,
      this.boundOnSelected,
    );
  }

  disconnect() {
    this.element.removeEventListener(
      SEARCHABLE_SELECT_SELECTED_EVENT,
      this.boundOnSelected,
    );
    super.disconnect();
  }

  productSelected(event: CustomEvent<SearchableSelectSelectedDetail>) {
    const purconPath = event.detail?.metadata?.purcon_path;
    if (!purconPath) return;

    window.dispatchEvent(
      new CustomEvent(ModalEvents.Open, {
        bubbles: true,
        cancelable: false,
        detail: {
          contentHref: purconPath,
        },
      }),
    );
  }
}
